import { ChangeDetectionStrategy, Component, ElementRef, OnInit, QueryList, ViewChildren } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Options } from 'src/app/core/core.module';

@Component({
  selector: 'app-account-creation',
  templateUrl: './account-creation.component.html',
  styleUrls: ['./account-creation.component.less'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class AccountCreationComponent implements OnInit{

  createFormGroup!: FormGroup;
  addressFormGroup!: FormGroup;
  contactFormGroup!: FormGroup;

  //suffixOptions: Options[] = [];
  saturationOptions: Options[] = [];
  suffixOptions: { text: string, value: string }[] = [
    { text: 'Jr', value: 'Jr' },
    { text: 'Sr', value: 'Sr' },
    { text: 'III', value: 'III' },
    { text: 'IV', value: 'IV' }
  ];
  genderOptions: { text: string, value: string }[] = [
    { text: 'Male', value: 'Male' },
    { text: 'Female', value: 'Female' },
    { text: 'Frog', value: 'Frog' }
  ];
  citizenshipOptions: { text: string, value: string }[] = [
    { text: 'Jr', value: 'Jr' },
    { text: 'Sr', value: 'Sr' },
    { text: 'III', value: 'III' },
    { text: 'IV', value: 'IV' }
  ];

  
  constructor() { }
  
  ngOnInit(): void {
    this.initOptions();
    this.initCreateFormGroup();
    this.initAddressFormGroup();
    this.initContactFormGroup();
  }

  initCreateFormGroup(){
    this.createFormGroup = new FormGroup({
      saturation: new FormControl(),
      firstName: new FormControl(),
      middleName: new FormControl(),
      lastName: new FormControl(),
      suffix: new FormControl(),
      gender: new FormControl(),
      pob: new FormControl(),
      dob: new FormControl(),
      citizenship: new FormControl(),
      country: new FormControl(),
      maritalStatus: new FormControl(),
      mothersName: new FormControl(),
      spouseName: new FormControl(),
      spouseDoB: new FormControl(),
    });
  }

  initAddressFormGroup(){
    this.addressFormGroup = new FormGroup({
      presentAddress1: new FormControl(),
      presentAddress2: new FormControl(),
      presentProvince: new FormControl(),
      presentCity: new FormControl(),
      presentPostalCode: new FormControl(),
      sameAsPermanent: new FormControl(),
      permanentAddress1: new FormControl(),
      permanentAddress2: new FormControl(),
      permanentProvince: new FormControl(),
      permanentCity: new FormControl(),
      permanentPostalCode: new FormControl()
    });
  }

  initContactFormGroup(){
    this.contactFormGroup = new FormGroup({
      residentialContactNumber: new FormControl(),
      mobileNumber: new FormControl(),
      emailAddress: new FormControl()
    });
  }


  initOptions(){
    this.saturationOptions.push(new Options(
      'AAAAAAAA',
      'AAAAAAAA',
      true
    ));

    this.saturationOptions.push(new Options(
      'BBBBBBBB',
      'BBBBBBBB',
      true
    ));
  }

}
